/** Both the API interceptor's ApiError and raw Axios errors are accepted. */
export function generationHttpStatus(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const value = error as { status?: number; response?: { status?: number } };
  return value.status ?? value.response?.status;
}

export const GENERATION_DISMISSED_EVENT = 'autoqm:generation-dismissed';
export const GENERATION_RECONNECT_MESSAGE = '서버 연결을 확인하고 있습니다. 연결되면 진행 상황과 저장된 결과를 자동으로 불러옵니다.';
// Orphaned jobs are resumed after a deploy AND after a stale worker heartbeat,
// so the fallback wording must not claim a server update happened.
export const GENERATION_RESUME_MESSAGE = '작업을 다시 이어가고 있습니다. 잠시만 기다려주세요.';
